// extracted by mini-css-extract-plugin
module.exports = {"root":"ArtistCard_root__1jGHl","info":"ArtistCard_info__vfM8j","name":"ArtistCard_name__8hdIY","counts":"ArtistCard_counts__T0IDW"};